<template>
  <div>
    <div class="FlexRight">
      <div @click="ExternalLinks">
        <div>八桂杯</div>
        <div>报名入口</div>
      </div>
    </div>
    <div class="FlexRight" style="margin-top: 50px;">
      <div @click="ExternalLinks1">
        <div>科技计划</div>
        <div>项目申报</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Vue from "vue";
import api from "@/comment/request/api";
export default {
  name: "FlexRight",
  components: {},
  setup(props, { attrs, slots, emit }) {
    const state = Vue.reactive({
      bim_url: '',
    });
    // const GoTop=()=>{
    //   window.scrollTo(0, 0);
    // }
    // 八桂杯
    api.GetConfigs('bim_url').success((res) => {
      state.bim_url = res.data.data.bim_url;
    });
    const ExternalLinks = (item) => {
        window.open(state.bim_url, "_black");
    };
    const ExternalLinks1 = (item) => {
        window.open('https://gxjskj.yunxida.com/', "_black");
    };
    return {
      state,
      ExternalLinks,
      ExternalLinks1
      // GoTop
    }
  },
}
</script>

<style lang="scss" scoped>
@import "/src/comment/comment";
.FlexRight{
  >div{
    cursor:pointer;
    padding: 15px 20px;
    background-color: white;
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2);
    >div{
      color: #008fd7;
      text-align: center;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      line-height: 25px;
    }
  }
}
</style>